import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AppHeader } from "@/components/layout/app-header";
import { AppSidebar } from "@/components/layout/app-sidebar";
import { MobileHeader } from "@/components/layout/mobile-header";
import { SupportChat } from "@/components/layout/support-chat";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { COOKIE_KEYS, getCookie } from "@/lib/cookies";
import { authStore } from "@/stores/auth-store";

export const Route = createFileRoute("/_app")({
	beforeLoad: ({ location }) => {
		const { user, isAuthenticated } = authStore.state;

		if (!isAuthenticated || !user) {
			return; // Handled by __root or auth layer if needed
		}

		const skipOnboarding = getCookie(COOKIE_KEYS.SKIP_ONBOARDING) === "true";

		if (!skipOnboarding && !user.hasViewedStarterOnboarding) {
			// Don't redirect if we are already on some onboarding pages (though _app usually doesn't wrap them)
			// But for safety, checking if data is missing
			if (!user.nickname) {
				throw redirect({
					to: "/onboarding/apelido",
					search: { next: location.pathname },
				});
			}
			if (!user.avatar) {
				throw redirect({
					to: "/onboarding/avatar",
					search: { next: location.pathname },
				});
			}
			if (user.colorModeTheme === null || user.colorModeTheme === undefined) {
				throw redirect({
					to: "/onboarding/tema",
					search: { next: location.pathname },
				});
			}
		}
	},
	component: AppLayoutRoute,
});

function AppLayoutRoute() {
	return (
		<SidebarProvider>
			<AppSidebar />
			<SidebarInset className="bg-zinc-50 dark:bg-zinc-950 flex flex-col min-h-screen relative w-full overflow-x-hidden">
				<MobileHeader />
				<AppHeader />
				<main className="flex-1 w-full mx-auto relative z-10 pb-10">
					<Outlet />
				</main>
				<SupportChat />
			</SidebarInset>
		</SidebarProvider>
	);
}
